<template>
  <div>
    <fetch-json :url="url">
      <template slot-scope="{ json: groups, loading }">
        <div v-if="loading">Загрузка...</div>
        <template v-else>
          <div v-if="groups && groups.length">
            <GisogdDocGroup
              v-for="group in groups"
              :group="group"
              :key="group.key"
              :project-schema="projectSchema"
              :section-id="sectionId"
              :is-open="groups.length == 1 || isOpen(group)"
              @group-collapsed="groupCollapsed"
              @group-opened="groupOpened"
            ></GisogdDocGroup>
          </div>
          <div v-else>
            <no-data-place-holder></no-data-place-holder>
          </div>
        </template>
      </template>
    </fetch-json>
  </div>
</template>
<script>
import GisogdDocGroup from "./GisogdDocGroup";
export default {
  props: {
    projectSchema: {
      required: true,
      type: String,
    },
    openedGroupKeys: {
      default: () => [],
      type: Array,
    },
    sectionId: {
      required: true,
      type: String,
    },
  },
  components: {
    GisogdDocGroup,
  },
  computed: {
    url() {
      return `v1/${this.projectSchema}/gisogddocgroups/${this.sectionId}`;
    },
  },
  methods: {
    groupOpened(group) {
      this.$emit(
        "change-opened-groups",
        this.openedGroupKeys.concat([group.key])
      );
    },
    groupCollapsed(group) {
      const existGroupIndex = this.openedGroupKeys.findIndex(
        (key) => key === group.key
      );
      if (existGroupIndex > -1) {
        const newArr = this.openedGroupKeys.slice();
        newArr.splice(existGroupIndex, 1);
        this.$emit("change-opened-groups", newArr);
      }
    },
    isOpen(group) {
      return this.openedGroupKeys.includes(group.key);
    },
  },
};
</script>
